module.exports = __webpack_public_path__ + "img/icon-personajes.4906c831.svg";